import { getPdf2SvgApiUrl } from '../../services/pdf2svg';

// Placeholder: Replace with your actual base64-encoded font string

function isFontObj(obj: any): obj is { data: Uint8Array; fontFamily: string } {
  return (
    obj &&
    typeof obj === 'object' &&
    obj.data &&
    obj.fontFamily &&
    typeof obj.fontFamily === 'string' &&
    typeof obj.data.length === 'number'
  );
}

// Helper to base64 encode Uint8Array
function uint8ToBase64(uint8: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < uint8.length; i++) {
    binary += String.fromCharCode(uint8[i]);
  }
  return btoa(binary);
}

// Define fallback system font
const SYSTEM_FONT_FALLBACK = 'Helvetica, Arial, sans-serif';

/**
 * Calls backend to convert PDF to SVG and returns the SVG string.
 * @param file - PDF file to render
 * @param pageNumber - (unused, always page 1 for now)
 * @param scale - (unused)
 * @returns Promise<RenderPdfSvgResult> (SVG string)
 */
export interface RenderPdfSvgResult {
  svgString: string;
  missingFonts?: string[]; // for compatibility, but will not be used
}

export async function renderPdfPageToSvg(
  file: File | null,
  pageNumber = 1,
  scale = 1.5
): Promise<RenderPdfSvgResult> {
  if (!file || !(file instanceof File)) {
    throw new Error('No valid PDF file provided');
  }
  const formData = new FormData();
  formData.append('file', file);
  try {
    const pdf2SvgApiUrl = getPdf2SvgApiUrl();
    const response = await fetch(pdf2SvgApiUrl, {
      method: 'POST',
      body: formData
    });
    if (!response.ok) {
      throw new Error('PDF to SVG conversion failed.');
    }
    const svgString = await response.text();
    return { svgString };
  } catch (error: any) {
    throw new Error(error?.message || 'Unknown error during PDF to SVG conversion.');
  }
}

